function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.769,
  y1: 0.835,
  x2: 0.177,
  y2: 0.205,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#004683",
  stopOpacity: 0.82
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(-103.436 -202.639)"
}, React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(59 153)",
  opacity: 0.9
}, React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(44.436 49.639)",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M69.263,131.277c0-11.488,14.774-49.189,65.318-54.747",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 9
}), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M0,0H95.565V59.239H0Z",
  transform: "translate(96.654 120.019)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 5
}), React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M133.716,136.815l-12,11.305,12,10.028",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M154.955,158.147l12.2-11.088-11.818-10.242",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y1: 25.647,
  x2: 6,
  transform: "translate(141.274 136.815)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}))));

var SvgFront = function SvgFront(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/front.0e035dfc.svg";
export { ForwardRef as ReactComponent };